'use strict'

const root = window
const rootNode = root.document.documentElement
import { addClass, removeClass } from './dom'

function setThemeFn(theme: string) {
	// 参数校验
	if (!rootNode) {
		console.error('配置或 rootNode 节点不能为空')
		return
	}

	// 检测系统主题（现代浏览器）
	const isDarkModeSupported = window.matchMedia && typeof window.matchMedia === 'function'
	const isDarkMode = isDarkModeSupported
		? window.matchMedia('(prefers-color-scheme: dark)').matches
		: false // IE 无法检测，默认为 false

	// 应用主题
	const applyTheme = () => {
		if (theme === 'auto') {
			if (isDarkMode) {
				addClass(rootNode, 'theme-dark')
				localStorage.setItem('touchui.theme', 'dark')
			} else {
				removeClass(rootNode, 'theme-dark')
				localStorage.setItem('touchui.theme', 'light')
			}
		} else {
			if (theme === 'dark') {
				addClass(rootNode, 'theme-dark')
				localStorage.setItem('touchui.theme', 'dark')
			} else {
				removeClass(rootNode, 'theme-dark')
				localStorage.setItem('touchui.theme', 'light')
			}
		}
	}

	// 自动检测暗夜模式并监听（仅现代浏览器支持）
	if (theme === 'auto' && isDarkModeSupported) {
		const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
		applyTheme() // 初次应用

		// 注册监听器
		const listener = (event: { matches: any }) => {
			if (event.matches) {
				addClass(rootNode, 'theme-dark')
			} else {
				removeClass(rootNode, 'theme-dark')
			}
		}
		mediaQuery.addEventListener('change', listener)

		// 清理监听器（可选）
		rootNode['_themeListener'] = listener
	} else {
		// 非自动模式或 IE，直接应用主题
		applyTheme()

		// 清理监听器（如果存在）
		if (rootNode['_themeListener']) {
			const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)')
			mediaQuery.removeEventListener('change', rootNode['_themeListener'])
			delete rootNode['_themeListener']
		}
	}
}

function setTheme(theme) {
	if (!theme) {
		return
	}
	setThemeFn(theme)
}
function getTheme() {
	return localStorage.getItem('touchui.theme')
}

// 修改导出方式，将setTheme作为具名导出
export { setTheme, getTheme }

// export default {
// 	setTheme: function (theme) {
// 		if (!theme) {
// 			return
// 		}
// 		setTheme(theme)
// 	},
// 	getTheme: function () {
// 		return localStorage.getItem('touchui.theme')
// 	},
// }
